import { render } from "./DrugOverlay.vue?vue&type=template&id=5943960a"
import script from "./DrugOverlay.vue?vue&type=script&lang=js"
export * from "./DrugOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__